import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '@fff-web/fff-utilities';
import useGetPricesByPlan from '../../utils/hooks/useGetPricesByPlan';
import { resolveCouponCodeByCountry } from './ProRatedUpgradeUtils';

const useUpgradeConfirmationState = () => {
  const [loading, setLoading] = useState(false);
  const { userInfo } = useUserContext();
  const captchaRef = useRef(null);
  const navigate = useNavigate();

  const { isLoadingPrices, seasonalPrice, annualPrice } = useGetPricesByPlan();
  const couponCode = resolveCouponCodeByCountry(userInfo);

  return {
    loading: isLoadingPrices || loading,
    setLoading,
    captchaRef,
    userInfo,
    prices: {
      seasonalPrice,
      annualPrice,
    },
    navigate,
    couponCode,
  };
};

export { useUpgradeConfirmationState };
